<template>
    <div class="c-form_upload_wrapper">
        <label
            class="c-form_upload"
            :class="getClasses"
            @dragover.prevent="updateDragDropFocus(true)"
            @dragleave.prevent="updateDragDropFocus(false)"
            @dragenter.prevent="updateDragDropFocus(true)"
            @drop.prevent="onFileChange"
        >
            <input
                class="c-form_upload__input"
                type="file"
                :accept="accept"
                :name="inputName"
                @change="onFileChange"
                ref="input"
            />

            <div class="c-form_upload__content">
                <div v-if="file !== null || existingFile !== null" class="c-form_upload__selected-file">
                    <span>{{ fileName }}</span>
                    <v-btn
                        type="icon"
                        icon="edit"
                        title="Zmień plik">
                    </v-btn>
                </div>
                <div v-else class="c-form_upload__tip">
                    <span>Przeciągnij plik tutaj lub</span>
                    <v-btn type="green" @click="$refs.input.click()">Załaduj plik ręcznie</v-btn>
                </div>
            </div>

            <div class="c-form_upload__hover" v-if="file === null">
                <span class="c-form_upload__hover-icon"></span>
                <span>Upuść plik</span>
            </div>
        </label>
        <form-error-msg :msg="error || getError"></form-error-msg>
    </div>
</template>

<script>
import VBtn from 'Components/VBtn'
import FormErrorMsg from "../Form/FormErrorMsg.vue";

export default {

    $_veeValidate: {
        name() {
            return this.inputName
        },
        value() {
            return this.value;
        },
    },

    props: {
        existingFile: String,
        value: null,
        error: String,
    },

    data() {
        return {
            file: null,
            dragDropFocus: false,
            dragDrop: true,
            accept: 'application/x-pkcs12',
        }
    },

    computed: {
        getClasses() {
            return {
                'c-form_upload--hovered': this.dragDropFocus,
                'c-form_upload--error' : this.getError || this.error,
            }
        },
        inputName() {
            var tmp_name = this.$vnode.data.model.expression.split('.')
            var name = ''

            if (tmp_name.length > 1)
                name = tmp_name[tmp_name.length - 1]
            else
                name = tmp_name[0]

            return this.name || name
        },
        getError() {
            var err = this.errors.items.filter((error) => {
                return (error.field === this.inputName)
            })

            if (err.length)
                return err[0].msg
            else
                return null
        },
        fileName() {
            if (this.file && this.file.name) {
                return this.file.name
            } else if (this.existingFile) {
                return this.existingFile
            } else {
                return null
            }
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.file = val
            },
        },
        file(val) {
            this.$emit('input', val)
        },
    },

    methods: {
        onFileChange(event) {
            if (this.dragDrop) {
                this.updateDragDropFocus(false)
            }
            const value = event.target.files || event.dataTransfer.files

            if (value && value.length) {
                if (this.dragDrop) {
                    if (value.length === 1) {
                        this.file = null
                    } else {
                        return false
                    }
                } else {
                    this.file = null
                }
                const file = value[0]
                if (this.checkType(file)) {
                    this.file = file
                } else {
                    this.$alert.error(
                        'Załączniki',
                        'Niewłaściwy format pliku. Akceptowane formaty: ' + this.accept
                    )
                    return false
                }
            }
        },
        updateDragDropFocus(focus) {
            this.dragDropFocus = focus
        },
        checkType(file) {
            if (!this.accept) return true
            const types = this.accept.split(',')
            if (types.length === 0) return true
            let valid = false
            for (let i = 0; i < types.length && !valid; i++) {
                const type = types[i].trim().toLowerCase()
                if (type) {
                    if (type.substring(0, 1) === '.') {
                        // check extension
                        const extIndex = file.name.lastIndexOf('.')
                        if (
                            extIndex >= 0 &&
                            file.name.substring(extIndex).toLowerCase() === type
                        ) {
                            valid = true
                        }
                    } else {
                        // check mime type
                        if (file.type.match(type)) {
                            valid = true
                        }
                    }
                }
            }
            return valid
        },
    },

    components: {
        FormErrorMsg,
        VBtn,
    },
}
</script>

<style lang="scss">
@import '~Style/_utils.scss';

.c-form_upload_wrapper {
    margin-bottom: 0.5rem;
}

.c-form_upload {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    border-radius: 4px;
    border: 2px dashed $c-border;
    background-color: #f9fafd;
    padding: 2rem;
    width: 100%;
    width: 100%;
    height: 6em;
    cursor: pointer;
    margin-bottom: 0;

    &--error {
        border-color: #D50000FF;
    }

    &__input {
        position: absolute;
        width: 1px;
        height: 0;
        opacity: 0;
        pointer-events: none;
    }
    &__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 100%;

        span {
            display: block;
            margin-bottom: 0.5rem;
        }
    }
    &__selected-file {
        align-items: center;
        display: flex;
        flex-direction: row;

        .c-btn {
            margin-left: 10px;
        }
    }
    &__hover {
        position: absolute;
        background-color: #f9fafd;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        font-weight: 600;

        transition: opacity 0.2s ease-in-out, visibility 0s 0.2s linear;
        opacity: 0;
        z-index: 2;

        &-icon {
            display: inline-block;
            width: 3.2rem;
            height: 3.2rem;

            background-image: url('#{$icons}/file.svg');
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
            margin-bottom: 1rem;
        }
    }
    &--hovered &__hover {
        transition-delay: 0s;
        opacity: 1;
    }
}
</style>
